import notesAPI from 'granite-admin/common/gateways/notes-api';
async function createNoteClicked(eventEmitter, values) {
  try {
    let response = await notesAPI.createNote(values);
    eventEmitter.emit('NOTES_SAVE_SUCCESS', response);
    return response;
  } catch (error) {
    eventEmitter.emit('NOTES_SAVE_FAILURE');
    throw error;
  }
}
async function fetchNotes(eventEmitter, values, payloadKey) {
  try {
    const {
      notes,
      nextPage,
      count
    } = await notesAPI.getNotes(values);
    if (payloadKey === 'nextPage') {
      eventEmitter.emit('NOTES_FETCH_SUCCESS', {
        notes,
        nextPage,
        count,
        page: values.page
      });
    } else {
      eventEmitter.emit('NOTES_FETCH_SUCCESS_ONSAVE', {
        notes,
        nextPage,
        count
      });
    }
  } catch (error) {
    eventEmitter.emit('NOTES_FETCH_FAILURE');
  }
}
export { createNoteClicked, fetchNotes };